import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

export const FormErrorsTranslator = () => {
  const { errors, touched, setFieldTouched } = useFormikContext();
  const { i18n } = useTranslation();

  useEffect(() => {
    Object.keys(errors).forEach((fieldName) => {
      if (Object.keys(touched).includes(fieldName)) {
        setFieldTouched(fieldName);
      }
    });
  }, [i18n.language, errors, touched, setFieldTouched]);

  return null;
};
